import { supabase } from '../../integrations/supabase/client';
import type { IOrganizationType } from '../../interfaces/organizationType.interface';
import type { IOrganizationTypeRepository } from '../interfaces/IOrganizationTypeRepository';

export class SupabaseOrganizationTypeRepository implements IOrganizationTypeRepository {
  async getByCountry(countryCode: string, contextType: string = 'client'): Promise<IOrganizationType[]> {
    const { data, error } = await supabase
      .from('country_organization_types')
      .select('*')
      .eq('country_code', countryCode)
      .eq('context_type', contextType)
      .eq('is_active', true)
      .order('display_order', { ascending: true });

    if (error) {
      console.error('Error fetching organization types:', error);
      throw new Error(`Failed to fetch organization types: ${error.message}`);
    }

    return (data || []) as IOrganizationType[];
  }

  async getById(id: string): Promise<IOrganizationType | null> {
    const { data, error } = await supabase
      .from('country_organization_types')
      .select('*')
      .eq('id', id)
      .eq('is_active', true)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return null; // Not found
      }
      console.error('Error fetching organization type:', error);
      throw new Error(`Failed to fetch organization type: ${error.message}`);
    }

    return data as IOrganizationType;
  }

  async getByCode(countryCode: string, orgTypeCode: string): Promise<IOrganizationType | null> {
    const { data, error } = await supabase
      .from('country_organization_types')
      .select('*')
      .eq('country_code', countryCode)
      .eq('org_type_code', orgTypeCode)
      .eq('is_active', true)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        return null; // Not found
      }
      console.error('Error fetching organization type:', error);
      throw new Error(`Failed to fetch organization type: ${error.message}`);
    }

    return data as IOrganizationType;
  }
}
